function height(el) {
	var height = 0;
	$(el).each(function () {
		var thisHeight = $(this).height();
		if (thisHeight > height) {
			height = thisHeight;
		}
		setTimeout(() => {
			$(el).height(height)
		}, 100)
	})
}
let header = {
	scrollActive: function () {
		let height = $('header').height()
		if ($(window).scrollTop() > height) {
			$('header').addClass('active')
		} else {
			$('header').removeClass('active')
		}
	},
	checkHeightHeader: function () {
		let height = $('header').outerHeight()
		let menuMobile = $('header .mobile-wrap')
		
		// menuMobile.css('padding-top', height)
		$('main').css('padding-top', height)
		
	},
}

function setBackgroundElement() {
	$('[setBackground]').each(function () {
		var background = $(this).attr('setBackground')
		$(this).css({
			"background-image": "url(" + background + ")",
			"background-size": "cover",
			"background-position": "center center"
		})
	})
	$('[setBackgroundRepeat]').each(function () {
		var background = $(this).attr('setBackgroundRepeat')
		$(this).css({
			"background-image": "url(" + background + ")",
			"background-repeat": "repeat"
		})
	})
}

function mappingMenu() {
	var menu = $('header .menu-list').mapping({
		mobileWrapper: 'header .mobile-wrap',
		mobileMethod: 'appendTo',
		desktopWrapper: 'header .bottom-wrap .left-wrap .main-menu',
		desktopMethod: 'appendTo',
		breakpoint: 1200
	})
}

function menuMobile() {
	let hambuger = $('.burger-bt-inner')
	let menuMB = $('.mobile-wrap')
	let searchBox = $('.searchbox-wrap')
	hambuger.on('click', function () {
		// console.log(1111);
		header.checkHeightHeader();
		$(this).toggleClass('active');
		menuMB.toggleClass('active');
		searchBox.removeClass('active');
	})

	$('.menu-list .has-dropdown').each(function () {
		$(this).append('<span class="icon-dropdown"></span>')
	})

	$('.menu-list .has-dropdown .icon-dropdown').on('click', function () {
		$(this).prev().slideToggle();
	})
}

function toggleSearch() {
	let button = $('.button-search')
	let searchBox = $('.searchbox-wrap')
	let close = $('.searchbox-wrap .button-close')
	let hambuger = $('.burger-bt-inner')
	let menuMB = $('.mobile-wrap')
	button.on('click', function () {
		searchBox.toggleClass('active');
		hambuger.removeClass('active');
		menuMB.removeClass('active');
	})
	close.on('click', function () {
		searchBox.toggleClass('active');
	})

}

function swiperInit() {
	// var swiper = new Swiper('.swiper-container', {
	// 	slidesPerView: 3,
	// 	slidesPerColumn: 2,
	// 	spaceBetween: 30,
	// 	slidesPerColumnFill: "row",
	// 	pagination: {
	// 		el: '.swiper-pagination',
	// 		clickable: true,
	// 	},
	// });
	var homeHightLights = new Swiper('.home-slide .swiper-container', {
		loop: true,
		autoplay: {
			delay: 5000,
			waitForTransition: true,
			disableOnInteraction: false,
		},
		slidesPerColumnFill: "row",
		watchSlidesProgress: true,
		watchSlidesVisibility: true,
		slidesPerView: 1,
		spaceBetween: 20,
		pagination: {
			el: '.home-slide .main-pagination',
			type: 'bullets',
			clickable: true,
		},
		navigation: {
			nextEl: '.home-slide .button-next',
			prevEl: '.home-slide .button-prev'
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				slidesPerGroup: 2,
			},
		}
	});
	var eventsDetailSlide = new Swiper('.om-events-detail .swiper-container', {
		loop: true,
		autoplay: {
			delay: 5000,
			waitForTransition: true,
			disableOnInteraction: false,
		},
		slidesPerColumnFill: "row",
		watchSlidesProgress: true,
		watchSlidesVisibility: true,
		slidesPerView: 1,
		spaceBetween: 20,
		pagination: {
			el: '.om-events-detail .main-pagination',
			type: 'bullets',
			clickable: true,
		},
		navigation: {
			nextEl: '.om-events-detail .button-next',
			prevEl: '.om-events-detail .button-prev'
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 17,
			},
		}
	});
	var videoDetailSlide = new Swiper('.om-video-detail .swiper-container', {
		// loop: true,
		autoplay: {
			delay: 5000,
			waitForTransition: true,
			disableOnInteraction: false,
		},
		slidesPerColumnFill: "row",
		watchSlidesProgress: true,
		watchSlidesVisibility: true,
		slidesPerView: 1,
		spaceBetween: 20,
		pagination: {
			el: '.om-video-detail .main-pagination',
			type: 'bullets',
			clickable: true,
		},
		navigation: {
			nextEl: '.om-video-detail .button-next',
			prevEl: '.om-video-detail .button-prev'
		},
		breakpoints: {
			576: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
				slidesPerColumn: 2,
			},
		}
	});
}

function backToTop() {
	let elem = $('.back-to-top')
	elem.on('click', function () {
		$('html, body').animate({
			scrollTop: 0,
		}, 1000)
	})
}

function resizeMinitor() {
	let widthMinitor = $(window).width();
	// console.log(widthMinitor);
	let heightMinitor = $(window).height();
	// console.log(heightMinitor);
}

function shareSocial() {
	$(".share-social").jsSocials({
		showLabel: false,
		showCount: false,
		shares: [{
				share: "facebook",
				logo: "fab fa-facebook-f"
			},
			{
				share: "twitter",
				logo: "fab fa-twitter"
			},
		]
	});
}

function scrollToSection() {
	let elemHeader = $('header').outerHeight();
	let elemLink = $('.about-page .about-nav li a');
	elemLink.on('click', function (e) {
		e.preventDefault();
		var hash = this.hash;
		$('html, body').animate({
			scrollTop: $(hash).offset().top - elemHeader
		}, 1000);
	})

}

let aboutNav = {
	scrollToSection: () => {
		let elemHeader = $('header').outerHeight();
		let elemLink = $('.about-page .about-nav li a');
		elemLink.on('click', function (e) {
			e.preventDefault();
			var hash = this.hash;
			$('html, body').animate({
				scrollTop: $(hash).offset().top - elemHeader
			}, 1000);
		})
	},
	stickyTop: () => {
		let height = $('header').outerHeight();
		let navMB = $('.main-nav-mb');
		navMB.css('top', height);
	},
	toggleClass: () => {
		let button = $('.main-nav-mb .toggle');
		let nav = $('.main-nav-mb .about-nav');
		button.on('click', function () {
			$(this).toggleClass('active');
			nav.slideToggle();
		});
	},
	init: () => {
		if ($(window).width() <= 1024) {
			aboutNav.toggleClass();
		}
		aboutNav.stickyTop();
		aboutNav.scrollToSection();
	}
}

function moveHtml(){
	let bannerFull = $('.banner-full');
	let bannerList = $('.banner-qc-list');
	let pages = $('.modulepager');
	let subZoneDetail = $('.box-category');
	let boxContact = $('.box-contact');

	bannerFull.appendTo('.banner-full-append');
	bannerList.appendTo('.banner-list-append');
	pages.insertAfter('.news-list-pages');
	subZoneDetail.prependTo('.detail-append');
	bannerList.appendTo('.detail-append')
	boxContact.appendTo('.box-contact-append')
}

$(document).on('scroll', function () {
	header.scrollActive()
});
$(window).on('resize', function () {
	resizeMinitor();
	header.checkHeightHeader();
});
$(document).ready(function () {
	setBackgroundElement();

	// header
	mappingMenu();
	menuMobile();
	header.checkHeightHeader();
	toggleSearch();
	
	// swiper
	swiperInit();

	// click link to scroll to section
	aboutNav.init();

	// socical share
	shareSocial();

	moveHtml();

	height($('.om-whaton .news-item.news-item-top .caption .title'));
	height($('.home-slide .news-item.news-item-big .caption .title'));

	$(".searchbox input").focus(function () {
		$(this).keyup(function (e) {
			if (e.keyCode == 13) {
				$(this).next().trigger("click");
			}
		});

	});
})
